import React from "react"
import type { StyleProps } from "@mallardbay/lib-react-components"

import type { QuoteInterfaceFieldsFragment } from "~graphql/generated/graphql"
import CancellationPolicyModal from "~components/shared/cancellation-policy-modal"
import { TextSmallUnderlined } from "~components/shared/todo-lib-react-components/text"
import COPY from "~config/copy-constants"

interface Props {
    readonly quote?: QuoteInterfaceFieldsFragment | null
}

export default function BookingSummaryCancellationPolicy({ quote }: Props) {
    const styles = useStyles()

    if (!quote) return null

    return (
        <CancellationPolicyModal
            cancellationPolicy={quote.listing.outfitter.cancellation_policy}
            renderTrigger={() => (
                <TextSmallUnderlined style={styles.text}>
                    {COPY.CANCELLATION_POLICY_INFO}
                </TextSmallUnderlined>
            )}
        />
    )
}

function useStyles() {
    const text: StyleProps = {
        marginTop: { base: 0, md: 2 },
    }

    return { text }
}
